import { render, staticRenderFns } from "./ViewPortPage.vue?vue&type=template&id=712b22fc&"
import script from "./ViewPortPage.vue?vue&type=script&lang=js&"
export * from "./ViewPortPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports